const initContact = (section) => {
    const contactItems = section.querySelectorAll('.js-contact-item');
    const mediaItems = section.querySelectorAll('.js-contact-media');

    if (!mediaItems || !contactItems) return;

    contactItems.forEach((item) => {
        const index = item.dataset.contactIndex;

        item.addEventListener('mouseenter', () => {
            mediaItems[index].classList.add('is-active');
        });

        item.addEventListener('mouseleave', () => {
            mediaItems[index].classList.remove('is-active');
        });
    });
};

export default initContact;
